export default "__VITE_ASSET__CMnTnRvR__"